export const FINDING_TYPES = [
  'VULNERABILITY',
  'MISCONFIGURATION',
  'BEST_PRACTICE',
] as const;

export type FindingType = (typeof FINDING_TYPES)[number];

export const FINDING_TYPE_SOURCES = ['AGENT', 'USER'] as const;

export type FindingTypeSource = (typeof FINDING_TYPE_SOURCES)[number];

export const CVSS_VECTOR_ORIGINS = ['AGENT', 'STANDARD'] as const;

export type CvssVectorOrigin = (typeof CVSS_VECTOR_ORIGINS)[number];

export const isCvssVectorOrigin = (value: unknown): value is CvssVectorOrigin =>
  CVSS_VECTOR_ORIGINS.some((origin) => origin === value);
